module.exports = __webpack_public_path__ + "media/images/knockout__pickarrow@3x-917fc5da3b2b9e05fa619c96eb868e58.png";